/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useEffect } from 'react';
import { useTrackingContext } from '../context/TrackingContext';
import { TrackingIDs } from '../@types/Tracking';

export const useTracking = (ids: TrackingIDs) => {
  const { setTrackingIDs } = useTrackingContext();

  useEffect(() => {
    if (!ids.idPixel && !ids.idGA && !ids.idGTM) return;

    setTrackingIDs(ids);
  }, [ids.idPixel, ids.idGA, ids.idGTM, ids.tipo]);
};
